import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Action } from '@ngrx/store';
import { Actions, Effect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { RequestService } from '../services/request.service';
import { PostOptions } from '../services/interfaces/request.interfaces';

import { of } from 'rxjs/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';

import { State } from '../reducers/index';
import {
  LoginAction,
  LOGIN_REQUEST,
  LOGIN_REQUEST_SUCCESS,
  LOGIN_REQUEST_FAILURE } from '../actions/login.action';
import { OVERLAY_FINISH } from '../actions/header.action';
import { PostCredentialsRequest, PostCredentialsResponse } from './interfaces/login.interfaces';

@Injectable()
export class LoginEffect {

  private options: PostOptions<PostCredentialsRequest, PostCredentialsResponse>;

  constructor(
    private requestService: RequestService,
    private actions$: Actions,
    private router: Router,
    private store: Store<State>
  ) {
    // request config
    this.options = {
      url: '/login',
      body: {
        username: '',
        password: ''
      },
      handlers: {
        success: this.success.bind(this),
        error: this.error.bind(this)
      }
    };
  }
  // set data on success
  public success(data: PostCredentialsResponse): void {
    if (localStorage.getItem('AfterRegistration') || (JSON.parse(localStorage.getItem('data')) && JSON.parse(localStorage.getItem('data')).time)) {
      localStorage.removeItem('AfterRegistration');
      this.router.navigate([localStorage.getItem('AppId') + (localStorage.getItem('Appointment') ? '/confirmation' : '/time')]);
    } else {
      this.router.navigate([localStorage.getItem('AppId') + '/cabinet']);
    }
    this.store.dispatch({ type: OVERLAY_FINISH });
    this.store.dispatch({
      type: LOGIN_REQUEST_SUCCESS,
      payload: {
        username: this.options.body.username,
        password: this.options.body.password,
        data: JSON.stringify(data),
        token: data.user.sessionToken
      }
    });
  }
  // error handler
  public error(httpErrorResponse: HttpErrorResponse): void {
    this.store.dispatch({ type: OVERLAY_FINISH });
    this.store.dispatch({
      type: LOGIN_REQUEST_FAILURE,
      payload: {
        error: httpErrorResponse
      }
    });
  }
  // login request
  @Effect()
  public login$: Observable<any> = this.actions$
    .ofType(LOGIN_REQUEST)
    .map((action: LoginAction) => action.payload)
    .exhaustMap(state => {
      this.options.body.username = state['username'];
      this.options.body.password = state['password'];
      this.requestService.post<PostCredentialsRequest, PostCredentialsResponse>(this.options);
      return Observable.of({
        type: 'LOGIN_REQUEST_PROCESSING'
      });
    });
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/effects/login.effect.ts